export default "__VITE_ASSET__BFH5g5lY__"